<template>
  <div>
    <el-form :inline="true" class="form-edit-name" ref="firstForm">
        <el-form-item>
        <elsa-input name="name" v-model.lazy="newName">
        </elsa-input>
        </el-form-item>
        <el-form-item class="edit-check-group">
        <span v-if="this.oldName != this.newName" class="confirm-edit" @click="confirmModalRename">
            {{ $t('assignments.details.confirm') }}
        </span>
        <span class="cancel-edit" @click="cancelRename">
            {{ $t('assignments.details.cancel') }}
        </span>
        </el-form-item>
    </el-form>
    <confirm-edit-name-modal
      :dialogVisible="modals.showConfirmEditName"
      append-to-body
      v-on:closed="modals.showConfirmEditName = false"
      v-on:edit="handleEditName"
      :is_rename_assignment_lib="is_rename_assignment_lib"
    />
  </div>
</template>

<script>
import ElsaInput from '@/components/common/Input'
import ConfirmEditNameModal from '@/components/modals/assignments/ConfirmEditNameModal'
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    oldName: {
      type: String,
      default: ''
    },
    is_rename_assignment_lib: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newName: '',
      modals: {
        showConfirmEditName: false,
      },
    }
  },
  components: {
    ElsaInput,
    ConfirmEditNameModal
  },
  computed: {
  },
  mounted() {
    this.newName = this.oldName
  },
  methods: {
    confirmModalRename() {
      if (this.newName != this.oldName)
        this.modals.showConfirmEditName = true;
    },
    cancelRename(){
        this.$emit('cancel-rename')
    },
    handleEditName(renameAssAssigned = false) {
      if (this.is_rename_assignment_lib)
        this.$emit('handle-edit-name', renameAssAssigned, this.newName);
      else
        this.$emit('handle-edit-name', this.newName);
      this.modals.showConfirmEditName = false;
    }
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../scss/_colors.scss';
.cancel-edit {
  cursor: pointer;
}
.confirm-edit {
  color: #478DFF;
  cursor: pointer;
  padding: 0px 10px;
  margin-top: -6px;
}
.form-edit-name {
  display: flex;
  justify-content: flex-start;
  padding-bottom: 0px;
  .el-form-item {
    margin-bottom: -12px;
  }
  .elsa-input {
    margin-top: -18px;
  }
  .edit-check-group {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-right: -28px;
    margin-top: -3px;
  }
}
</style>
